import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../util/assets';
import Button from '../Button';
import useStoreReferralAttributes from '../../../hooks/useStoreReferralAttributes/useStoreReferralAttributes';
import AccountReferralItem from '../../../apps/pro/views/Account/AccountReferralsSettings/components/AccountReferralItem/AccountReferralItem';
import { ACCOUNT_REFERRAL_TYPE } from '../../../constants/account-referrals';
import AppStoreLink from '../AppStoreLink';
import PlayStoreLink from '../PlayStoreLink';

const propTypes = {
  title: PropTypes.string,
  content: PropTypes.any,
  accountReferralType: PropTypes.string,
  onDismiss: PropTypes.func,
};

const PurchaseSuccessWithReferral = ({
  title = 'Thank you for your order!',
  content,
  accountReferralType,
  onDismiss,
}) => {
  const { user } = useStoreReferralAttributes();

  const icon = (() => {
    switch (accountReferralType) {
      case ACCOUNT_REFERRAL_TYPE.SHUTTERBUG_PROMO:
        return '/cloud-value-illustration.svg';
      default:
        return undefined;
    }
  })();

  return (
    <div className="purchase-success-referral-wrapper">
      <img
        src={getAsset('/confetti-transparent.png')}
        alt="Confetti"
        className="purchase-success-referral-confetti"
      />
      <div className="d-flex mb-2">
        <img
          src={getAsset('/waldo-excited.png')}
          alt="Waldo logo"
          className="purchase-success-referral-logo"
          width="75px"
        />
      </div>
      <h2 className="mt-0 text-center text-white">{title}</h2>

      <AccountReferralItem
        accountReferralType={accountReferralType}
        user={user}
        icon={icon}
        className="purchase-success-referral-item"
      />

      {content}

      <p className="text-white text-center mt-2">
        Don&rsquo;t have the Waldo App? Download Now!
      </p>

      <div className="purchase-success-app-icons">
        <AppStoreLink width={60} />
        <PlayStoreLink width={60} />
      </div>

      {onDismiss && (
        <Button
          btnStyle="white"
          btnSize="lg"
          className="mt-2"
          onClick={onDismiss}
        >
          Dismiss
        </Button>
      )}
    </div>
  );
};

export { PurchaseSuccessWithReferral as PurchaseSuccessWithReferralComponent };

PurchaseSuccessWithReferral.propTypes = propTypes;

export default PurchaseSuccessWithReferral;
